import { useMemo } from 'react';

import { CardBackground } from '../card/card.config';
import { CardGrid } from '../card-grid/card-grid';
import { getComponentFromProps, getPropsFromModel } from '../../utils/use-child-components';
import { useDragComponentsPlaceholder } from '../../utils/use-drag-components-placeholder';

import { CardsContainerProps } from './cards-container.config';

import './cards-container.scss';

const CardsContainer = ({
  accessibilityLabel,
  additionalClasses,
  background,
  cqPath,
  cqItems,
  cqItemsOrder,
  getGridProps,
  id,
  isInEditor,
  roleAttribute,
}: CardsContainerProps) => {
  const { placeholder } = useDragComponentsPlaceholder({
    className: 'snowflake-cards-container-placeholder-component',
    cqPath,
    isInEditor,
  });

  const childComponents = useMemo(
    () =>
      cqItemsOrder?.map((cqItem) => {
        const cqItemProps = cqItems[cqItem];
        const cardProps = getPropsFromModel(cqItemProps, cqPath, cqItem);
        const Card = getComponentFromProps(cardProps);

        return Card && <Card {...cardProps} key={cqItem} />;
      }),
    [cqItems, cqItemsOrder, cqPath]
  );

  return (
    <div
      aria-label={accessibilityLabel}
      className={additionalClasses}
      data-testid="snowflake-cards-container"
      id={id}
      role={roleAttribute}
    >
      <CardGrid
        getGridProps={getGridProps}
        items={childComponents as JSX.Element[]}
        cardBackground={background || CardBackground.GREY}
        cqPath={cqPath}
      />

      {placeholder}
    </div>
  );
};

export default CardsContainer;
